import { schemas } from 'constants/schemas';
import type { Country } from 'models/country';
import { normalizeResponse } from 'utils/normalize/normalize';

import { apiV3 } from 'services/apiV3';

export const fetch = async ({ locale = 'EN' }) => {
  const countries = await apiV3.countries.fetch({ locale });

  return normalizeCountries(countries);
};

export const normalizeCountries = <T extends Partial<Country> = Country>(
  countries: T[],
): {
  entities?: {
    countries: Record<string, Country>;
  };
  result?: string[];
} => {
  return countries.length
    ? normalizeResponse<{
        countries: Record<string, Country>;
      }>(countries, schemas.arrayOfCountries)
    : {};
};
